(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6941);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Button */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var Button = function(param) {
    var label = param.label, href = param.href, onClick = param.onClick;
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full text-c-secondary m-auto cursor-pointer font-bold font-RocknRoll md:text-3xl text-xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "flex justify-end",
                children: label
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full bg-c-primary text-c-white py-3 md:px-36 px-28 cursor-pointer rounded-md font-bold",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "flex justify-center text-sm md:text-xl",
                children: label
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewsCard */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var NewsCard = function(param) {
    var day = param.day, title = param.title, onClick = param.onClick, opacity = param.opacity;
    return opacity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onClick,
        className: "flex justify-between cursor-pointer items-center bg-c-secondary md:p-6 p-4 font-light md:font-normal md:mt-6 mt-4 md:h-[112px] h-[80px] overflow-hidden bg-opacity-80 font-RocknRoll",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col justify-start self-center overflow-hidden text-[#05151F]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "w-max md:text-xl text-sm text-c-primary",
                        children: day
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "w-full md:text-2xl text-base md:h-9 h-6 truncate",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "images/news-arrow-blue.svg",
                    alt: "\u77E2\u5370",
                    className: "md:h-auto h-6 ml-3"
                })
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onClick,
        className: "flex justify-between cursor-pointer items-center bg-c-secondary md:p-6 p-4 font-light md:font-normal md:mt-6 mt-4 md:h-[145px] h-[80px] overflow-hidden font-RocknRoll",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col justify-start self-center overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "w-full md:text-xl text-sm text-c-primary",
                        children: day
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "w-full md:text-2xl text-base md:h-9 h-6 truncate",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "images/news-arrow-blue.svg",
                    alt: "\u77E2\u5370",
                    className: "md:h-auto h-6 ml-3"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsCard);


/***/ }),

/***/ 1796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommonMeta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);


function CommonMeta(param) {
    var _title = param.title, title = _title === void 0 ? "TV\u30A2\u30CB\u30E1\u300E\u60D1\u661F\u306E\u3055\u307F\u3060\u308C\u300F\u516C\u5F0F\u30B5\u30A4\u30C8" : _title, _description = param.description, description = _description === void 0 ? "\u300C\u60D1\u661F\uFF08\u307B\u3057\uFF09\u306E\u3055\u307F\u3060\u308C\u300D2022\u5E74\u590FTV\u30A2\u30CB\u30E1\u653E\u9001\u958B\u59CB\uFF01" : _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat("https://hoshinosamidare.jp", "/images/ogp.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1.0,viewport-fit=cover"
            })
        ]
    });
};


/***/ }),

/***/ 6941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TopPage": function() { return /* binding */ TopPage; },
  "TopPageView": function() { return /* binding */ TopPageView; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(5934);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/react-twitter-embed/dist/index.modern.js
var index_modern = __webpack_require__(9512);
// EXTERNAL MODULE: ./src/components/global/CButton.tsx
var CButton = __webpack_require__(1674);
// EXTERNAL MODULE: ./src/components/global/CNewsCard.tsx
var CNewsCard = __webpack_require__(601);
;// CONCATENATED MODULE: ./src/components/global/CVerticalTitle.tsx

var VerticalTitle = function(param) {
    var title = param.title, largeTitle = param.largeTitle;
    return largeTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rotate-90 text-c-secondary font-bold w-max h-20 md:text-[96px] text-2xl tracking-widest font-RocknRoll",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: title
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rotate-90 text-c-secondary font-bold w-max h-20 md:text-5xl text-2xl tracking-widest font-RocknRoll",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: title
        })
    });
};
/* harmony default export */ var CVerticalTitle = ((/* unused pure expression or super */ null && (VerticalTitle)));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 169 modules
var motion = __webpack_require__(2748);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/process/browser.js
var browser = __webpack_require__(4155);
// EXTERNAL MODULE: ./src/components/head/commonMeta.tsx
var commonMeta = __webpack_require__(1796);
;// CONCATENATED MODULE: ./src/components/layout/Top.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background: url(/images/bg-bottom.png) no-repeat bottom,\n        linear-gradient(180deg, #2d1627 0%, #0c062d 40%, #0c062d 37.51%, #4083e8 53.65%, #87ccfd 71.73%);\n    background-size: contain;\n    width: 100vw;\n    min-height: 100vh;\n    background-attachment: local;\n    /* @media (max-width: ",
        "px) {\n        background: url(/images/bg-bottom.png) no-repeat bottom, linear-gradient(180deg, #2d1627 0%, #150a50 45%, #83c9fd 70%, #83c9fd 100%);\n        // \u898B\u5207\u308C\u308B\u3088\u3046\u306B\u3059\u308B\u305F\u3081\u3042\u3048\u3066\u56FA\u5B9A\u5024\n        background-size: 900px;\n    } */\n    @media (max-width: ",
        "px) {\n        background: url(/images/bg-bottom.png),\n            linear-gradient(\n                180deg,\n                rgba(45, 22, 39, 1) 0%,\n                rgba(21, 10, 80, 1) 50%,\n                rgba(21, 10, 80, 1) 240vh,\n                rgba(131, 201, 253, 1) 60%,\n                rgba(131, 201, 253, 1) 100%\n            );\n        background-position: bottom;\n        background-repeat: no-repeat;\n        // \u898B\u5207\u308C\u308B\u3088\u3046\u306B\u3059\u308B\u305F\u3081\u3042\u3048\u3066\u56FA\u5B9A\u5024\n        background-size: 600px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: 40vw;\n    left: 0;\n    height: 200vw;\n    margin: auto;\n    transform: rotate(45deg);\n    width: 100vw;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    width: 1px;\n    height: 80%;\n    top: 0;\n    left: 50%;\n\n    &::after {\n        content: '';\n        display: block;\n        position: absolute;\n        height: 100vh;\n        width: 100%;\n        top: -60%;\n        left: 0;\n        background-color: #ffffff;\n        animation: drop 6s 0s infinite;\n        animation-fill-mode: forwards;\n    }\n\n    :first-of-type {\n        margin-left: -45%;\n        &::after {\n            animation-delay: 1.2s;\n        }\n    }\n    :nth-of-type(2) {\n        margin-left: 12px;\n        &::after {\n            zoom: 0.5;\n            animation-delay: -0.2s;\n        }\n    }\n    :nth-of-type(3) {\n        margin-left: -28%;\n        &::after {\n            animation-delay: 4.5s;\n        }\n    }\n    :nth-of-type(4) {\n        margin-left: 18%;\n        &::after {\n            animation-delay: 3.3s;\n        }\n    }\n    :last-of-type {\n        margin-left: 35%;\n        &::after {\n            animation-delay: 2.5s;\n        }\n    }\n\n    @keyframes drop {\n        0% {\n            top: -45%;\n            height: 100vw;\n        }\n        80% {\n            height: 0;\n        }\n        100% {\n            height: 0;\n            top: 100%;\n        }\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: -250vw;\n    display: flex;\n    position: relative;\n    justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    margin: 64px 5vw;\n    max-width: 1800px;\n    width: 90vw;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    opacity: 0;\n    bottom: 50px;\n    max-width: 1800px;\n    width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: center;\n    font-size: 0.92rem;\n    font-weight: bold;\n    color: #ffffff;\n    letter-spacing: 0.1em;\n    width: 100vw;\n    padding-bottom: 40px;\n    @media (max-width: ",
        "px) {\n        padding-bottom: 16px;\n        font-size: 0.62rem;\n    }\n    @media (orientation: landscape) and (max-width: ",
        "px) {\n        font-size: 0.62rem;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var spWidth = 599;
var tabletWidth = 820;
var pcWidth = 1024;
var Bg = emotion_styled_browser_esm/* default.main */.Z.main(_templateObject(), tabletWidth, spWidth);
var Stars = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var Star = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var KeyVisualArea = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var KeyVisual = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
var KeyVisualImg = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject5());
var Footer = emotion_styled_browser_esm/* default.footer */.Z.footer(_templateObject6(), spWidth, pcWidth);
var TopLayout = function(param) {
    var children = param.children;
    (0,react.useEffect)(function() {
        (0,browser.nextTick)(_asyncToGenerator(runtime_default().mark(function _callee() {
            var kvs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, kv;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        kvs = [
                            ".kv_bottom",
                            ".kv_mid",
                            ".kv_top",
                            "logo"
                        ];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 2;
                        _iterator = kvs[Symbol.iterator]();
                    case 4:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _ctx.next = 11;
                            break;
                        }
                        kv = _step.value;
                        _ctx.next = 8;
                        return gsap/* gsap.to */.p8.to(kv, {
                            opacity: 1,
                            delay: 0.3,
                            duration: 0.6,
                            bottom: 0
                        });
                    case 8:
                        _iteratorNormalCompletion = true;
                        _ctx.next = 4;
                        break;
                    case 11:
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](2);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.prev = 18;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 20:
                        _ctx.prev = 20;
                        if (!_didIteratorError) {
                            _ctx.next = 23;
                            break;
                        }
                        throw _iteratorError;
                    case 23:
                        return _ctx.finish(20);
                    case 24:
                        return _ctx.finish(17);
                    case 25:
                        _ctx.next = 27;
                        return gsap/* gsap.to */.p8.to(".logo", {
                            opacity: 1,
                            duration: 0.8
                        });
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    13,
                    17,
                    25
                ],
                [
                    18,
                    ,
                    20,
                    24
                ]
            ]);
        })));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        animate: {
            opacity: 1
        },
        initial: {
            opacity: 0
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bg, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(commonMeta/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-screen h-[250vw] overflow-hidden pointer-events-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stars, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(KeyVisualArea, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(KeyVisual, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "kv_bottom w-full",
                                    src: "/images/top/kv_bottom.jpg",
                                    alt: "\u30AD\u30FC\u30D3\u30B8\u30E5\u30A2\u30EB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyVisualImg, {
                                    className: "kv_mid",
                                    src: "/images/top/kv_mid.png",
                                    alt: "\u30AD\u30FC\u30D3\u30B8\u30E5\u30A2\u30EB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyVisualImg, {
                                    className: "kv_top",
                                    src: "/images/top/kv_top.png",
                                    alt: "\u30AD\u30FC\u30D3\u30B8\u30E5\u30A2\u30EB"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "logo opacity-0 absolute w-4/5 max-w-xl md:h-[52vw] h-[68vw] md:bottom-[0.6%] -bottom-[12%]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/logo.svg",
                                    alt: "\u60D1\u661F\uFF08\u307B\u3057\uFF09\u306E\u3055\u307F\u3060\u308C",
                                    layout: "fill",
                                    objectFit: "contain"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full relative z-[1]",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        children: "\xa9\u6C34\u4E0A\u609F\u5FD7\u30FB\u5C11\u5E74\u753B\u5831\u793E\uFF0F\u3042\u308B\u6642\u4EE3\u306E\u6307\u8F2A\u306E\u9A0E\u58EB\u56E3"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/utils/createApiClient.ts + 1 modules
var createApiClient = __webpack_require__(1277);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(6870);
;// CONCATENATED MODULE: ./src/pages/index.tsx
function pages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function pages_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                pages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                pages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    color: #ffffff;\n    line-height: 90px;\n    letter-spacing: 0.1em;\n    font-size: clamp(2.3rem, 6.2vw, 3.8rem);\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pages_templateObject1() {
    var data = pages_taggedTemplateLiteral([
        "\n    line-height: 70px;\n    letter-spacing: 0.1em;\n    font-size: clamp(1.5rem, 3vw, 2.4rem);\n    @media (max-width: 767px) {\n        margin-top: -16px;\n    }\n"
    ]);
    pages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function pages_templateObject2() {
    var data = pages_taggedTemplateLiteral([
        "\n    line-height: 29px;\n    letter-spacing: 0.1em;\n    font-size: clamp(0.72rem, 4vw, 1.25rem);\n    margin-top: 32px;\n    @media (max-width: 767px) {\n        margin-top: 12px;\n    }\n"
    ]);
    pages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function pages_templateObject3() {
    var data = pages_taggedTemplateLiteral([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    max-width: 900px;\n    width: 75%;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 100%;\n    color: #000000;\n    margin: auto;\n    margin-top: 112px;\n    @media (max-width: ",
        "px) {\n        font-size: 16px;\n        margin-top: 72px;\n    }\n    @media (max-width: ",
        "px) {\n        font-size: 16px;\n        margin-top: 80px;\n    }\n"
    ]);
    pages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function pages_templateObject4() {
    var data = pages_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: end;\n    margin: auto;\n    max-width: 900px;\n    width: 75%;\n    margin-top: 24px;\n    @media (max-width: ",
        "px) {\n        margin-top: 32px;\n    }\n    @media (max-width: ",
        "px) {\n        margin-top: 16px;\n    }\n"
    ]);
    pages_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function pages_templateObject5() {
    var data = pages_taggedTemplateLiteral([
        "\n    background: url(/images/top-hammer.png) no-repeat center;\n    width: 100vw;\n    color: #ffffff;\n    margin-top: 48px;\n    font-size: clamp(1.5rem, 5.7vw, 3.6rem);\n    text-shadow: #036eb7 0px 0px 30px, #036eb7 0.540302px 0.841471px 0px, #036eb7 -0.416147px 0.909297px 0px,\n        #036eb7 -0.989992px 0.14112px 0px, #036eb7 -0.653644px -0.756802px 0px, #036eb7 0.283662px -0.958924px 0px,\n        #036eb7 0.96017px -0.279415px 0px;\n    @media (max-width: ",
        "px) {\n        background: url(/images/top-hammer.png) no-repeat top;\n        padding: 0 4%;\n        margin-top: 0px;\n    }\n"
    ]);
    pages_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function pages_templateObject6() {
    var data = pages_taggedTemplateLiteral([
        "\n    font-weight: 400;\n    font-size: clamp(1rem, 3.2vw, 2rem);\n    line-height: 72px;\n    text-align: center;\n    margin: 78px 14%;\n    @media (max-width: ",
        "px) {\n        margin: 32px 12px 0px;\n        font-size: 16px;\n        line-height: 200%;\n    }\n"
    ]);
    pages_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = pages_taggedTemplateLiteral([
        "\n    position: relative;\n    padding: 32px;\n    max-width: 960px;\n    margin: auto;\n    @media (max-width: 1160px) {\n        width: 75%;\n    }\n    @media (max-width: ",
        "px) {\n        padding: 16px 12px;\n    }\n    @media (max-width: 382px) {\n        padding: 16px 12px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = pages_taggedTemplateLiteral([
        "\n    display: flex;\n    margin: auto;\n    margin-top: 240px;\n    margin-right: 40px;\n    cursor: pointer;\n    max-width: 900px;\n    height: auto;\n    @media (max-width: ",
        "px) {\n        max-width: 640px;\n        margin-top: 120px;\n        margin-right: 20px;\n    }\n    @media (max-width: ",
        "px) {\n        margin: 0px 8px;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = pages_taggedTemplateLiteral([
        "\n    display: flex;\n    margin: auto;\n    margin-top: 240px;\n    margin-left: 40px;\n    cursor: pointer;\n    max-width: 900px;\n    height: auto;\n    @media (max-width: ",
        "px) {\n        max-width: 640px;\n        margin-top: 120px;\n        margin-left: 20px;\n    }\n    @media (max-width: ",
        "px) {\n        margin: 24px 8px;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}













var pages_spWidth = 599;
var pages_tabletWidth = 912;
var Onair = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject());
var OnairCompany = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject1());
var OnairAttention = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject2());
var News = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject3(), pages_tabletWidth, pages_spWidth);
var SeeMore = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject4(), pages_tabletWidth, pages_spWidth);
var Story = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject5(), pages_spWidth);
var StoryText = emotion_styled_browser_esm/* default.div */.Z.div(pages_templateObject6(), pages_spWidth);
var Twitter = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7(), pages_spWidth);
var BookBanner = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8(), pages_tabletWidth, pages_spWidth);
var ShindanBanner = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9(), pages_tabletWidth, pages_spWidth);
var TopPageView = function(param) {
    var article = param.article, onClickArticle = param.onClickArticle, onClickToShindan = param.onClickToShindan;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pt-[12.5vw] md:pt-0 pb-[118.125vw] md:pb-[64.583vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:py-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Onair, {
                            className: "font-RocknRoll",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "md:mt-8 mt-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-c-secondary",
                                            children: "2022"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "md:text-3xl text-2xl",
                                            children: "\u5E74"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-c-secondary",
                                            children: "7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "md:text-3xl text-2xl",
                                            children: "\u6708"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnairCompany, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "md:flex justify-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "MBS/TBS\u7CFB"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "md:mt-0 -mt-8",
                                                    children: "\u30A2\u30CB\u30E1\u30A4\u30BA\u30E0\u67A0\u3001"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "md:mt-0 -mt-8",
                                                    children: "\u3068\u3061\u304E\u30C6\u30EC\u30D3\u3001"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "md:flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "md:mt-0 -mt-8",
                                                    children: "BS11\u3001AT-X\u3001"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "md:mt-0 -mt-8",
                                                    children: "\u30C6\u30EC\u30D3\u5317\u6D77\u9053"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "md:mt-0 -mt-8",
                                                    children: "\u306B\u3066\u653E\u9001\u958B\u59CB\uFF01"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OnairAttention, {
                                    children: "\u203B\u653E\u9001\u60C5\u5831\u306F\u5909\u66F4\u3068\u306A\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(News, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute md:top-24 top-8 md:-left-44 -left-24",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalTitle, {
                                        title: "\u30CB\u30E5\u30FC\u30B9"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (article === null || article === void 0 ? void 0 : article.list.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: article === null || article === void 0 ? void 0 : article.list.map(function(it) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return onClickArticle(it.uuid);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CNewsCard/* default */.Z, {
                                                    day: (0,date/* formatUsDay */.L2)(it.publish_start_at),
                                                    title: it.title,
                                                    opacity: false
                                                })
                                            }, it.uuid);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "\u8A18\u4E8B\u304C\u3042\u308A\u307E\u305B\u3093"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SeeMore, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CButton/* default */.Z, {
                                href: "/news",
                                label: "MORE >"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Story, {
                    className: "font-RocknRoll",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center py-[368px] md:py-[200px] lg:py-[287px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "md:w-max w-auto m-auto",
                                children: "\u30A4\u30F3\u30C8\u30ED\u30C0\u30AF\u30B7\u30E7\u30F3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryText, {
                                children: [
                                    "\u3054\u304F\u666E\u901A\u306E\u5E73\u51E1\u5927\u5B66\u751F\u3060\u3063\u305F\u96E8\u5BAE\u5915\u65E5\u306F\u3001\u3042\u308B\u65E5\u73FE\u308C\u305F\u558B\u308B\u30C8\u30AB\u30B2\u306B\u300C\u5730\u7403\u306E\u5371\u6A5F\u300D\u3092\u6551\u3046\u5354\u529B\u3092\u4F9D\u983C\u3055\u308C\u308B\u3002\u62D2\u5426\u3059\u308B\u9593\u3082\u306A\u304F\u7363\u306E\u9A0E\u58EB\u56E3\u306E\u4E00\u54E1\u3068\u306A\u3063\u305F\u5915\u65E5\u306F\u3001\u6307\u8F2A\u306E\u529B\u3067\u8D85\u80FD\u529B\u30FB\u638C\u63E1\u9818\u57DF\u304C\u4E0E\u3048\u3089\u308C\u308B\u304C\u3001\u65E9\u304F\u3082\u6575\u306B\u8972\u308F\u308C\u3066\u3057\u307E\u3046\u3002\u7D76\u4F53\u7D76\u547D\u306E\u305D\u306E\u6642\u3001\u5915\u65E5\u3092\u6551\u3063\u305F\u306E\u306F\u306A\u3093\u3068\u304A\u96A3\u306B\u4F4F\u3080\u5C11\u5973\u30FB\u3055\u307F\u3060\u308C\u3060\u3063\u305F\u3002\u6551\u4E16\u4E3B\u306E\u964D\u81E8\u3068\u601D\u3044\u304D\u3084\u3001\u5B9F\u306F\u3055\u307F\u3060\u308C\u306F\u5730\u7403\u5F81\u670D\u3092\u4F01\u3080\u9B54\u738B\u3060\u3063\u305F\u2026\u2026\u3002",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "md:mt-12 mt-6",
                                        children: "\u305D\u306E\u3067\u305F\u3089\u3081\u306A\u5F37\u3055\u3068\u9B54\u738B\u7684\u9B45\u529B\u306B\u60F9\u304B\u308C\u305F\u5915\u65E5\u306F\u5F7C\u5973\u306E\u4E0B\u50D5\u3068\u306A\u308A\u3001\u5F7C\u5973\u304C\u671B\u3080\u5225\u306E\u601D\u60D1\u306B\u52A0\u62C5\u3059\u308B\u4E8B\u306B\u306A\u308B\u3002"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Twitter, {
                    className: "bg-c-secondary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute md:top-28 -top-2 md:-left-56 -left-32",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalTitle, {
                                title: "\u516C\u5F0FTwitter"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute md:-top-14 -top-8 left-1 md:p-0 md:w-48 w-28",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/noi.svg",
                                alt: "\u30CE\u30A4\u306E\u30B7\u30EB\u30A8\u30C3\u30C8"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[900px] mb-154 mx-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* TwitterTimelineEmbed */.kV, {
                                onLoad: function noRefCheck() {},
                                lang: "ja",
                                options: {
                                    height: 379,
                                    width: "100%"
                                },
                                screenName: "AnimeSamidare",
                                sourceType: "profile"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:flex lg:px-44 md:px-28 md:mt-0 mt-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookBanner, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                href: "https://www.shonengahosha.co.jp/topics_Info.php?id=7850",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex m-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "images/banner-book-pc.png",
                                        alt: "\u539F\u4F5C\u30D0\u30CA\u30FC",
                                        srcSet: "images/banner-book.png 900w"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShindanBanner, {
                            onClick: onClickToShindan,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "images/banner-kishimaker-pc.png",
                                    alt: "\u9A0E\u58EB\u56E3\u30E1\u30FC\u30AB\u30FC\u30D0\u30CA\u30FC",
                                    srcSet: "images/banner-kishimaker.png 900w"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var TopPage = function() {
    var router = (0,next_router.useRouter)();
    var apiClient = (0,createApiClient/* createApiClient */.U)();
    var _query = router.query, page = _query.page, limit = _query.limit;
    var articleParams = (0,react.useMemo)(function() {
        var ref, ref1;
        return {
            page: (ref = parseInt(page !== null && page !== void 0 ? page : "1")) !== null && ref !== void 0 ? ref : 1,
            limit: (ref1 = parseInt(limit !== null && limit !== void 0 ? limit : "3")) !== null && ref1 !== void 0 ? ref1 : 1
        };
    }, [
        page,
        limit
    ]);
    var data = (0,es.useQuery)([
        articleParams
    ], pages_asyncToGenerator(runtime_default().mark(function _callee() {
        var body;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return apiClient.api.article.get({
                        query: articleParams
                    });
                case 2:
                    body = _ctx.sent.body;
                    return _ctx.abrupt("return", body);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        // initialData: article,
        keepPreviousData: false
    }).data;
    var onClickArticle = function() {
        var _ref = pages_asyncToGenerator(runtime_default().mark(function _callee(newsId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return router.push({
                            pathname: "news/[newsId]",
                            query: {
                                newsId: newsId
                            }
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickArticle(newsId) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickToShindan = function() {
        router.push({
            pathname: "/shindan"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopPageView, {
        article: data,
        onClickArticle: onClickArticle,
        onClickToShindan: onClickToShindan
    });
};
/* harmony default export */ var pages = (TopPage);


/***/ }),

/***/ 1277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ createApiClient; }
});

// EXTERNAL MODULE: ./node_modules/@aspida/axios/dist/index.js
var dist = __webpack_require__(8416);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/aspida/dist/index.js
var aspida_dist = __webpack_require__(7116);
;// CONCATENATED MODULE: ./src/apis/$api.ts
// prettier-ignore

// prettier-ignore
var api = function(param) {
    var baseURL = param.baseURL, fetch = param.fetch;
    var prefix = (baseURL === undefined ? "" : baseURL).replace(/\/$/, "");
    var PATH0 = "/api/article";
    var PATH1 = "/api/book";
    var PATH2 = "/api/goods";
    var PATH3 = "/api/goods/category";
    var PATH4 = "/api/onair";
    var PATH5 = "/api/onair/show";
    var PATH6 = "/api/story";
    var GET = "GET";
    return {
        api: {
            article: {
                _uid: function(val2) {
                    var prefix2 = "".concat(PATH0, "/").concat(val2);
                    return {
                        get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json();
                        },
                        $get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json().then(function(r) {
                                return r.body;
                            });
                        },
                        $path: function() {
                            return "".concat(prefix).concat(prefix2);
                        }
                    };
                },
                get: function(option) {
                    return fetch(prefix, PATH0, GET, option).json();
                },
                $get: function(option) {
                    return fetch(prefix, PATH0, GET, option).json().then(function(r) {
                        return r.body;
                    });
                },
                $path: function(option) {
                    return "".concat(prefix).concat(PATH0).concat(option && option.query ? "?".concat((0,aspida_dist.dataToURLString)(option.query)) : "");
                }
            },
            book: {
                _uid: function(val2) {
                    var prefix2 = "".concat(PATH1, "/").concat(val2);
                    return {
                        get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json();
                        },
                        $get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json().then(function(r) {
                                return r.body;
                            });
                        },
                        $path: function() {
                            return "".concat(prefix).concat(prefix2);
                        }
                    };
                },
                get: function(option) {
                    return fetch(prefix, PATH1, GET, option).json();
                },
                $get: function(option) {
                    return fetch(prefix, PATH1, GET, option).json().then(function(r) {
                        return r.body;
                    });
                },
                $path: function(option) {
                    return "".concat(prefix).concat(PATH1).concat(option && option.query ? "?".concat((0,aspida_dist.dataToURLString)(option.query)) : "");
                }
            },
            goods: {
                _uid: function(val2) {
                    var prefix2 = "".concat(PATH2, "/").concat(val2);
                    return {
                        get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json();
                        },
                        $get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json().then(function(r) {
                                return r.body;
                            });
                        },
                        $path: function() {
                            return "".concat(prefix).concat(prefix2);
                        }
                    };
                },
                category: {
                    get: function(option) {
                        return fetch(prefix, PATH3, GET, option).json();
                    },
                    $get: function(option) {
                        return fetch(prefix, PATH3, GET, option).json().then(function(r) {
                            return r.body;
                        });
                    },
                    $path: function(option) {
                        return "".concat(prefix).concat(PATH3).concat(option && option.query ? "?".concat((0,aspida_dist.dataToURLString)(option.query)) : "");
                    }
                },
                get: function(option) {
                    return fetch(prefix, PATH2, GET, option).json();
                },
                $get: function(option) {
                    return fetch(prefix, PATH2, GET, option).json().then(function(r) {
                        return r.body;
                    });
                },
                $path: function(option) {
                    return "".concat(prefix).concat(PATH2).concat(option && option.query ? "?".concat((0,aspida_dist.dataToURLString)(option.query)) : "");
                }
            },
            onair: {
                _uid: function(val2) {
                    var prefix2 = "".concat(PATH4, "/").concat(val2);
                    return {
                        get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json();
                        },
                        $get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json().then(function(r) {
                                return r.body;
                            });
                        },
                        $path: function() {
                            return "".concat(prefix).concat(prefix2);
                        }
                    };
                },
                show: {
                    get: function(option) {
                        return fetch(prefix, PATH5, GET, option).json();
                    },
                    $get: function(option) {
                        return fetch(prefix, PATH5, GET, option).json().then(function(r) {
                            return r.body;
                        });
                    },
                    $path: function() {
                        return "".concat(prefix).concat(PATH5);
                    }
                },
                get: function(option) {
                    return fetch(prefix, PATH4, GET, option).json();
                },
                $get: function(option) {
                    return fetch(prefix, PATH4, GET, option).json().then(function(r) {
                        return r.body;
                    });
                },
                $path: function() {
                    return "".concat(prefix).concat(PATH4);
                }
            },
            story: {
                _uid: function(val2) {
                    var prefix2 = "".concat(PATH6, "/").concat(val2);
                    return {
                        get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json();
                        },
                        $get: function(option) {
                            return fetch(prefix, prefix2, GET, option).json().then(function(r) {
                                return r.body;
                            });
                        },
                        $path: function() {
                            return "".concat(prefix).concat(prefix2);
                        }
                    };
                },
                get: function(option) {
                    return fetch(prefix, PATH6, GET, option).json();
                },
                $get: function(option) {
                    return fetch(prefix, PATH6, GET, option).json().then(function(r) {
                        return r.body;
                    });
                },
                $path: function() {
                    return "".concat(prefix).concat(PATH6);
                }
            }
        }
    };
};
// prettier-ignore
/* harmony default export */ var $api = (api);

;// CONCATENATED MODULE: ./src/utils/createApiClient.ts
/* provided dependency */ var process = __webpack_require__(4155);



var createApiClient = function() {
    var baseUrl = process.env.BASE_URL || "https://samidare-api.hoshinosamidare.jp/" || 0;
    return $api(dist_default()(axios_default().create({
        baseURL: baseUrl
    })));
};


/***/ }),

/***/ 6870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ formatUsDay; },
/* harmony export */   "fG": function() { return /* binding */ formatDay; }
/* harmony export */ });
/* unused harmony export formatDayBetween */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

var formatDay = function(dateStr) {
    return dateStr ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStr).format("YYYY/MM/DD") : "";
};
var formatUsDay = function(dateStr) {
    return dateStr ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStr).format("YYYY.MM.DD") : "";
};
var formatDayBetween = function(startDateStr, endDateStr) {
    if (startDateStr === endDateStr) return startDateStr ? dayjs(startDateStr).format("YYYY/MM/DD") : "";
    else {
        return (startDateStr ? dayjs(startDateStr).format("YYYY/MM/DD") : "") + "-" + (endDateStr ? dayjs(endDateStr).format("YYYY/MM/DD") : "");
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [416,487,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);